import { FC } from "react";
import { styled } from "@mui/system";
import { Span } from "../Typography";
import { eventCardData } from "./event-table-data";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";

const StyledTable = styled(Table)(({ theme }) => ({
  "& td": {
    paddingTop: "1.2rem",
    paddingBottom: "1.2rem",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  "& #TableBodyRow": {
    "&:last-child td": {
      borderBottom: theme.palette.grey[300],
    },
  },
}));

const Status = styled(Span)<{ status: string }>(({ theme, status }) => ({
  fontSize: 12,
  borderRadius: 5,
  padding: "3px 8px",
  color:
    status === "200 OK"
      ? theme.palette.success.main
      : status === "404 NOT"
      ? theme.palette.warning.main
      : status === "500 ERR" && theme.palette.error.main,
  background:
    status === "200 OK"
      ? "#e8fff3"
      : status === "404 NOT"
      ? "#fff8dd"
      : "#fff5f8",
}));

const EventTable: FC = () => {
  return (
    <StyledTable sx={{ minWidth: 500 }}>
      <TableBody>
        {eventCardData.map((row, index) => {
          return (
            <TableRow tabIndex={-1} key={row.date} id="TableBodyRow">
              <TableCell padding="none" align="left">
                <Status status={row.status}>{row.status}</Status>
              </TableCell>
              <TableCell align="left">{row.request}</TableCell>
              <TableCell padding="none" align="right">
                {row.date}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </StyledTable>
  );
};

export default EventTable;
